import React from 'react';
import { Table } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import {
	QUES_CODE_PREFIX,
	formatBrsrNumericCellValue,
	getFormattedTextEmbeddedinLITag,
	renderQuestionAnswer
} from '../../../../core/utilities/BRSRUtils';
import './../Reporting.scss';

const BRSRPrinciple5 = ({
	t,
	page7,
	yearFilter
}) => {


	const renderP5Q1 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page7?.['previousYear']) {
			page7['previousYear'][QUES_CODE_PREFIX + 'P5-1']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>1. Employees and workers who have been provided training on human rights issues and policy(ies) of the entity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={2}>Category</th>
								<th colSpan={3} className='FY_class text-center white-nowrap'>FY {yearFilter}</th>
								<th colSpan={3} className='text-center white-nowrap'>FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Total (A)</th>
								<th className='FY_class_sub'>No. of employees / workers covered (B)</th>
								<th className='FY_class_sub'>% (B/A)</th>
								<th>Total (C)</th>
								<th>No. of employees / workers covered (C)</th>
								<th>% (D/C)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={7} className="text-center font-color"><strong>Employees</strong></td>
							</tr>
							<tr>
								<td>Permanent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1ab'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1ac'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other than permanent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1bb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1bc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Total</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1cb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1cb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1cc'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={7} className="text-center font-color"><strong>Workers</strong></td>
							</tr>
							<tr>
								<td>Permanent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1db'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1db'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1dc'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other than permanent</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1ea'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1eb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1ec'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1ea'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1eb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1ec'] ?? ''}</td>
							</tr>
							<tr>
								<td>Total</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1fa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1fb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-1fc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1fa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1fb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-1fc'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q2 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page7?.['previousYear']) {
			page7['previousYear'][QUES_CODE_PREFIX + 'P5-2']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>2. Details of minimum wages paid to employees and workers, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={3}>Category</th>
								<th colSpan={5} className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th colSpan={5} className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th rowSpan={2} className='FY_class_sub'>Total (A)</th>
								<th colSpan={2} className='FY_class_sub'>Equal to Minimum Wage</th>
								<th colSpan={2} className='FY_class_sub'>More than Minimum Wage</th>
								<th rowSpan={2} >Total (D)</th>
								<th colSpan={2}>Equal to Minimum Wage</th>
								<th colSpan={2}>More than Minimum Wage</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>No. (B)</th>
								<th className='FY_class_sub'>% (B/A)</th>
								<th className='FY_class_sub'>No. (C)</th>
								<th className='FY_class_sub'>% (C/A)</th>
								<th>No. (E)</th>
								<th>% (E/D)</th>
								<th>No. (F)</th>
								<th>% (F/D)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td colSpan={11} className="text-center font-color"><strong>Employees</strong></td>
							</tr>
							<tr>
								<td><strong>Permanent</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2aa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ab'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ac'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ad'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ae'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2aa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ab'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ac'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ad'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ae'] ?? ''}</td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ba'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2bb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2bc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2bd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2be'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ba'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2bb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2bc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2bd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2be'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ca'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2cb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2cc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2cd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ce'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ca'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2cb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2cc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2cd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ce'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Other than permanent</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2da'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2db'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2dc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2dd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2de'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2da'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2db'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2dc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2dd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2de'] ?? ''}</td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ea'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2eb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ec'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ed'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ee'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ea'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2eb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ec'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ed'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ee'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2fa'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2fb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2fc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2fd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2fe'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2fa'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2fb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2fc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2fd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2fe'] ?? ''}</td>
							</tr>
							<tr>
								<td colSpan={11} className="text-center font-color"><strong>Workers</strong></td>
							</tr>
							<tr>
								<td><strong>Permanent</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ga'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2gb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2gc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2gd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ge'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ga'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2gb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2gc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2gd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ge'] ?? ''}</td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ha'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2hb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2hc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2hd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2he'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ha'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2hb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2hc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2hd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2he'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ia'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ib'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ic'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2id'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ie'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ia'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ib'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ic'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2id'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ie'] ?? ''}</td>
							</tr>
							<tr>
								<td><strong>Other than permanent</strong></td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ja'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2jb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2jc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2jd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2je'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ja'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2jb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2jc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2jd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2je'] ?? ''}</td>
							</tr>
							<tr>
								<td>Male</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ka'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2kb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2kc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2kd'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ke'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ka'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2kb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2kc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2kd'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ke'] ?? ''}</td>
							</tr>
							<tr>
								<td>Female</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2la'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2lb'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2lc'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2ld'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-2le'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2la'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2lb'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2lc'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2ld'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-2le'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q3a = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className="table_list01">
				<b>a. Median remuneration / wages</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={2}></th>
								<th colSpan={2} className='text-center'>Male</th>
								<th colSpan={2} className='text-center'>Female</th>
							</tr>
							<tr>
								<th>Number</th>
								<th>Median remuneration/ salary/ wages of respective category</th>
								<th>Number</th>
								<th>Median remuneration/ salary/ wages of respective category</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Board of Directors (BoD)</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a1a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a1b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a1c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a1d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Key Managerial Personnel</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a2a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a2b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a2c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a2d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Employees other than BoD and KMP</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a3a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a3b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a3c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a3d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Workers</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a4a'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a4b'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a4c'] ?? ''}</td>
								<td className='text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3a4d'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q3b = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page7?.['previousYear']) {
			page7['previousYear'][QUES_CODE_PREFIX + 'P5-3']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className="table_list01">
				<b>b. Gross wages paid to females as % of total wages paid by the entity, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th>Category</th>
								<th className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Gross wages paid to females as % of total wages</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-3b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-3b'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q4 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>4. Do you have a focal point (Individual/ Committee) responsible for addressing human rights impacts or issues caused or contributed to by the business? <strong><i>(Yes/No)</i></strong></b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-4a'] ?? '')}
				</div>
			</div>
		);
	};

	const renderP5Q5 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>5. Describe the internal mechanisms in place to redress grievances related to human rights issues.</b>
				<div className='my-2'>{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-5a'] ?? '')}</div>
			</div>
		);
	};

	const renderP5Q6 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-6']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page7?.['previousYear']) {
			page7['previousYear'][QUES_CODE_PREFIX + 'P5-6']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>6. Number of Complaints on the following made by employees and workers:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th rowSpan={2}></th>
								<th colSpan={3} className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th colSpan={3} className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
							<tr>
								<th className='FY_class_sub'>Filed during the year</th>
								<th className='FY_class_sub'>Pending resolution at the end of year</th>
								<th className='FY_class_sub'>Remarks</th>
								<th>Filed during the year</th>
								<th>Pending resolution at the end of year</th>
								<th>Remarks</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Sexual Harassment</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-1a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-1b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-1c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-1a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-1b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-1c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Discrimination at workplace</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-2a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-2b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-2c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-2a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-2b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-2c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Child Labour</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-3a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-3b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-3c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-3a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-3b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-3c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Forced Labour/Involuntary Labour</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-4a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-4b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-4c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-4a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-4b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-4c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Wages</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-5a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-5b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-5c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-5a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-5b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-5c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Other human rights related issues</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-6a'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-6b'] ?? ''}</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-6-6c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-6a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-6b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-6-6c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q7 = () => {
		const currentYearAnswer = {};
		const previousYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-7']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		if (page7?.['previousYear']) {
			page7['previousYear'][QUES_CODE_PREFIX + 'P5-7']?.keyValues?.forEach(val => {
				previousYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>7. Complaints filed under the Sexual Harassment of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013, in the following format:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th className="text-center FY_class white-nowrap">FY {yearFilter}</th>
								<th className="text-center white-nowrap">FY {yearFilter - 1}</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Total Complaints reported under Sexual Harassment on of Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013 (POSH)</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-7a'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-7a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Complaints on POSH as a % of female employees / workers</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-7b'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-7b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Complaints on POSH upheld</td>
								<td className='FY_class_content text-right'>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-7c'] ?? ''}</td>
								<td className='text-right'>{previousYearAnswer[QUES_CODE_PREFIX + 'P5-7c'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q8 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-8']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>8. Mechanisms to prevent adverse consequences to the complainant in discrimination and harassment cases.</b>
				<div className='my-2'>{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-8a'] ?? '')}</div>
			</div>
		);
	};

	const renderP5Q9 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-9']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>9. Do human rights requirements form part of your business agreements and contracts? (Yes/No)</b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-9a'] ?? '')}
				</div>
			</div>
		);
	};

	const renderP5Q10 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-10']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>10. Assessments for the year:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>% of your plants and offices that were assessed (by entity or statutory authorities or third parties)</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Child labour</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-10a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Forced/involuntary labour</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-10b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Sexual harassment</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-10c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Discrimination at workplace</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-10d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Wages</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-10e'] ?? ''}</td>
							</tr>
							<tr>
								<td>Others – please specify</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-10f'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5Q11 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-11']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}

		return (
			<div className='brsr-list-item'>
				<b>11. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 10 above.</b>
				<div className='my-2'>{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-11a'] ?? '')}</div>
			</div>
		);
	};

	const renderP5LIQ1 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-LI1']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>1. Details of a business process being modified / introduced as a result of addressing human rights grievances/complaints.</b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI1a'] ?? '')}
				</div>
			</div>
		);
	};

	const renderP5LIQ2 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-LI2']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>2. Details of the scope and coverage of any Human rights due-diligence conducted.</b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI2a'] ?? '')}
				</div>
			</div>
		);
	};

	const renderP5LIQ3 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-LI3']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>3. Is the premise/office of the entity accessible to differently abled visitors, as per the requirements of the Rights of Persons with Disabilities Act, 2016?</b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI3a'] ?? '')}
				</div>
			</div>
		);
	};

	const renderP5LIQ4 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-LI4']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>4. Details on assessment of value chain partners:</b>
				<div className="mt-2">
					<Table bordered size="sm">
						<thead>
							<tr>
								<th></th>
								<th>% of value chain partners (by value of business done with such partners) that were assessed</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Sexual Harassment</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI4a'] ?? ''}</td>
							</tr>
							<tr>
								<td>Discrimination at workplace</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI4b'] ?? ''}</td>
							</tr>
							<tr>
								<td>Child Labour</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI4c'] ?? ''}</td>
							</tr>
							<tr>
								<td>Forced Labour/Involuntary Labour</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI4d'] ?? ''}</td>
							</tr>
							<tr>
								<td>Wages</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI4e'] ?? ''}</td>
							</tr>
							<tr>
								<td>Others – please specify</td>
								<td>{currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI4f'] ?? ''}</td>
							</tr>
						</tbody>
					</Table>
				</div>
			</div>
		);
	};

	const renderP5LIQ5 = () => {
		const currentYearAnswer = {};
		if (page7?.['currentYear']) {
			page7['currentYear'][QUES_CODE_PREFIX + 'P5-LI5']?.keyValues?.forEach(val => {
				currentYearAnswer[val.key] = formatBrsrNumericCellValue(val.value);
			});
		}
		return (
			<div className='brsr-list-item'>
				<b>5. Provide details of any corrective actions taken or underway to address significant risks / concerns arising from the assessments at Question 4 above.</b>
				<div className='my-2'>
					{getFormattedTextEmbeddedinLITag(currentYearAnswer[QUES_CODE_PREFIX + 'P5-LI5a'] ?? '')}
				</div>
			</div>
		);
	};

	return (
		<section id="PRINCIPLE_5" className="Main_Section PRINCIPLE_5">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head">
						<h5>PRINCIPLE 5: Businesses should respect and promote human rights</h5>
					</div>
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head">
								<b>Essential Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP5Q1()}
									{renderP5Q2()}
									<div className='brsr-list-item'>
										<b>3. Details of remuneration / wages paid to employees and workers:</b>
										{renderP5Q3a()}
										{renderP5Q3b()}
									</div>
									{renderP5Q4()}
									{renderP5Q5()}
									{renderP5Q6()}
									{renderP5Q7()}
									{renderP5Q8()}
									{renderP5Q9()}
									{renderP5Q10()}
									{renderP5Q11()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 2">
					<div className="ETA_card_Section_sub">
						<section className="mb-4">
							<div className="ETA_card_Section_sub_head mb-3">
								<b>Leadership Indicators</b>
							</div>
							<div className="ETA_card_Section_sub_body">
								<div className='brsr-list'>
									{renderP5LIQ1()}
									{renderP5LIQ2()}
									{renderP5LIQ3()}
									{renderP5LIQ4()}
									{renderP5LIQ5()}
								</div>
							</div>
						</section>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRPrinciple5);
